import { useState } from "react";

const Range = () => {
  const [setRangeval] = useState(null);

  return (
    <div>
      <span>Rare</span>
      <input
        type="range"
        className="custom-range"
        min="1"
        max="5"
        onChange={(event) => setRangeval(event.target.value)}
      />
      <span>Well-Done</span>
    </div>
  );
};

export default Range;
